<template>
  <div
    class="pointer-events-none absolute left-1/2 -translate-x-1/2"
    style="background: radial-gradient(ellipse at center, color-mix(in oklch, var(--ui-primary) 6%, transparent) 0%, transparent 70%);"
  />
</template>
